<div class="card mt-3">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="mb-0">Benefit Eligibility: Conferences</h2>
      <button type="button" class="btn btn-link p-1" title="Conference eligibility help" (click)="showHelp = true">
        <i class="fas fa-question-circle"></i>
      </button>
    </div>

    <div class="text-center p-3" *ngIf="loading">
      <i class="material-icons rotate text-muted">loop</i>
    </div>

    <ng-container *ngIf="view">
      <ul class="nav nav-tabs mt-3">
        <li class="nav-item">
          <button type="button" class="nav-link"
                  [class.active]="activeTab === 'eligibility'"
                  (click)="selectTab('eligibility')">
            Eligibility
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link"
                  [class.active]="activeTab === 'applications'"
                  (click)="selectTab('applications')">
            My Applications
          </button>
        </li>
      </ul>

      <div class="pt-3" *ngIf="activeTab === 'eligibility'">
        <div class="row">
          <div class="col-12 col-lg-4">
            <b>Role Category</b>
            <div>{{view.eligibility.roleCategoryName || 'Not assigned'}}</div>
          </div>
          <div class="col-4 col-lg-2 mt-2 mt-lg-0">
            <b>Accrued</b>
            <div>{{view.eligibility.accruedHours | number:'1.2-2'}} hrs</div>
          </div>
          <div class="col-4 col-lg-2 mt-2 mt-lg-0">
            <b>Reserved</b>
            <div>{{view.eligibility.reservedHours | number:'1.2-2'}} hrs</div>
          </div>
          <div class="col-4 col-lg-2 mt-2 mt-lg-0">
            <b>Used</b>
            <div>{{view.eligibility.utilizedHours | number:'1.2-2'}} hrs</div>
          </div>
          <div class="col-12 col-lg-2 mt-2 mt-lg-0">
            <b>Available</b>
            <div>{{view.eligibility.availableHours | number:'1.2-2'}} hrs</div>
          </div>
        </div>

        <div class="row border-top mt-3 pt-3">
          <div class="col-12 col-md-4">
            <b>KRA/KPI</b>
            <div>{{view.eligibility.kraAverageScore == null ? 'Unknown' :
              (view.eligibility.kraAverageScore >= view.eligibility.kraThreshold ? 'Meets' : 'Below')}}</div>
          </div>
          <div class="col-12 col-md-4 mt-2 mt-md-0">
            <b>File Review</b>
            <div>{{view.eligibility.fileReviewScore == null ? 'Unknown' :
              (view.eligibility.fileReviewScore >= view.eligibility.fileReviewThreshold ? 'Meets' : 'Below')}}</div>
          </div>
          <div class="col-12 col-md-4 mt-2 mt-md-0">
            <b>Standing</b>
            <div>{{view.eligibility.isInGoodStanding ? 'Good standing' : 'Needs review'}}</div>
          </div>
        </div>

        <h3 class="mt-4">Eligibility by Level</h3>
        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Level</th>
                <th>Required Hours</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let level of view.eligibility.levelResults">
                <td>{{level.levelLabel}}</td>
                <td>{{level.requiredHours | number:'1.2-2'}}</td>
                <td>
                  <span [class.text-success]="level.eligible" [class.text-warning]="!level.eligible">
                    {{getLevelStatus(level)}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex align-items-center justify-content-between mt-4">
          <h3 class="mb-0">Open Opportunities</h3>
          <a class="btn btn-secondary btn-thin" routerLink="/conference-eligibility/apply" *ngIf="selfView">
            <i class="fas fa-plus"></i> New Conference Request
          </a>
        </div>
        <div class="table-responsive mt-2">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Conference</th>
                <th>Location</th>
                <th>Dates</th>
                <th>Level</th>
                <th *ngIf="selfView"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let opportunity of view.openOpportunities">
                <td>{{opportunity.title}}</td>
                <td>{{opportunity.location || '-'}}</td>
                <td>{{opportunity.startDate | date:'M/d/yy'}} - {{opportunity.endDate | date:'M/d/yy'}}</td>
                <td>{{opportunity.levelLabel}}</td>
                <td class="text-right" *ngIf="selfView">
                  <ng-container *ngIf="getLatestApplication(opportunity.id || opportunity.iD || opportunity.ID) as application; else applyForOpportunity">
                    <span class="badge mr-2" [ngClass]="isActiveApplication(application) ? 'badge-info' : 'badge-secondary'">
                      {{application.statusLabel}}
                    </span>
                    <button type="button" class="btn btn-link p-0 mr-2" (click)="viewApplication(application)">View application</button>
                    <a *ngIf="!isActiveApplication(application)" class="btn btn-primary btn-thin"
                       [routerLink]="['/conference-eligibility/apply', opportunity.id || opportunity.iD || opportunity.ID]">
                      Apply again
                    </a>
                  </ng-container>
                  <ng-template #applyForOpportunity>
                    <a class="btn btn-primary btn-thin"
                       [routerLink]="['/conference-eligibility/apply', opportunity.id || opportunity.iD || opportunity.ID]">
                      Apply
                    </a>
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="!view.openOpportunities.length">
                <td [attr.colspan]="selfView ? 5 : 4" class="text-muted">No open conference opportunities.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-3" *ngIf="activeTab === 'applications'">
        <label for="show-past-conference-applications">
          <input id="show-past-conference-applications" type="checkbox" [(ngModel)]="showPastApplications" />
          Show past conferences
        </label>
      </div>

      <div class="table-responsive mt-2" *ngIf="activeTab === 'applications'">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Conference</th>
              <th>Dates</th>
              <th>Level</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let application of visibleApplications">
              <td>{{application.conferenceTitle}}</td>
              <td>
                <ng-container *ngIf="application.conferenceStartDate && application.conferenceEndDate; else noConferenceDates">
                  {{application.conferenceStartDate | date:'M/d/yy'}} - {{application.conferenceEndDate | date:'M/d/yy'}}
                </ng-container>
                <ng-template #noConferenceDates>-</ng-template>
              </td>
              <td>{{application.levelLabel}}</td>
              <td>
                {{application.statusLabel}}
                <span class="badge badge-warning ml-1" *ngIf="application.isException">Exception</span>
              </td>
              <td class="text-right">
                <button type="button" class="btn btn-link p-0" (click)="viewApplication(application)">View details</button>
              </td>
            </tr>
            <tr *ngIf="!visibleApplications.length">
              <td colspan="5" class="text-muted">
                {{showPastApplications ? 'No conference applications.' : 'No current conference applications. Select Show past conferences to view older applications.'}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog header="Conference Eligibility Help" [modal]="true" [style]="{width: '60vw'}" [(visible)]="showHelp">
  <p>{{view?.helpText}}</p>
  <p class="mb-0">This is an individual employee view. Executive, Director, and Department rollups are not used here.</p>
</p-dialog>

<p-dialog header="Conference Application" [modal]="true" [style]="{width: '75vw'}" [(visible)]="showApplication">
  <ng-container *ngIf="selectedApplication">
    <h3>{{selectedApplication.conferenceTitle}}</h3>
    <div><b>Status:</b> {{selectedApplication.statusLabel}}</div>
    <div><b>Dates:</b> {{selectedApplication.conferenceStartDate | date:'M/d/yy'}} - {{selectedApplication.conferenceEndDate | date:'M/d/yy'}}</div>
    <div><b>Submitted:</b> {{selectedApplication.submittedDate | date:'M/d/yy h:mm a'}}</div>
    <div class="alert alert-warning mt-3" *ngIf="selectedApplication.isException">
      <b>Exception review requested</b>
      <ul class="mb-0">
        <li *ngFor="let reason of selectedApplication.exceptionReasons">{{reason}}</li>
      </ul>
    </div>
    <h4 class="mt-3" *ngIf="selectedApplication.answers.length">Answers</h4>
    <div class="border-top pt-2 mt-2" *ngFor="let answer of selectedApplication.answers">
      <b>{{answer.questionPrompt}}</b>
      <div>{{answer.hasFile ? answer.fileName : (answer.displayAnswer || '-')}}</div>
    </div>
    <h4 class="mt-3">History</h4>
    <div class="border-top pt-2 mt-2" *ngFor="let history of selectedApplication.statusHistory">
      <b>{{history.statusLabel}}</b> by {{history.changedByName}} on {{history.changedDate | date:'M/d/yy h:mm a'}}
      <div *ngIf="history.notes">{{history.notes}}</div>
    </div>
    <button type="button" class="btn btn-danger mt-3" *ngIf="canCancel(selectedApplication)"
            (click)="cancelApplication()">
      Cancel Application
    </button>
  </ng-container>
</p-dialog>
